var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHelpFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm.165 16.986c-.548-.095-1.066.3-1.16.844a1 1 0 101.97.34l.01-.057c.094-.544-.276-1.033-.82-1.127zM12 4.944c-2.243 0-4 1.757-4 4a1 1 0 002 0c0-1.141.86-2 2-2 1.103 0 2 .945 2 2.107 0 .764-.228 1.219-.87 1.738-1.901 1.54-2.118 3.356-2.131 4.002v.12a.991.991 0 001.073 1.02c.544-.038.956-.516.925-1.06v-.067c.004-.286.11-1.422 1.392-2.46C15.503 11.442 16 10.426 16 9.05c0-2.265-1.795-4.107-4-4.107z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconHelpFilled;